'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'light-switch';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e017';
var svgPathData = 'M368 16l0 480L16 496 16 16l352 0zM16 0L0 0 0 16 0 496l0 16 16 0 352 0 16 0 0-16 0-480 0-16L368 0 16 0zM272 400l-160 0 0-136 160 0 0 136zM112 112l160 0 0 136-160 0 0-136zm0-16L96 96l0 16 0 288 0 16 16 0 160 0 16 0 0-16 0-288 0-16-16 0L112 96zm96-40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 400a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightSwitch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;